/* eslint-disable react-hooks/exhaustive-deps */
import { Divider } from 'antd'
import { useAppSelector } from 'src/app/hooks'
import { UserSaleOffer } from 'src/core/models'
import React, { useState, useEffect } from 'react'
import { CustomCard, CustomTable } from 'src/components'
import { ctOffersColumns } from 'src/core/table-columns'
import { getFilteredUserSaleOffers } from 'src/core/helpers'
import { currencyListSelector, userSaleOffersSelector } from 'src/features'
import ClimatetradeOffersFilter from './ClimatetradeOffersFilter/ClimatetradeOffersFilter'

const ClimatetradeOffersCard: React.FC = () => {
  const { data: ctOffers } = useAppSelector(userSaleOffersSelector)
  const currencyList = useAppSelector(currencyListSelector)
  const [filterText, setFilterText] = useState<string>(null)
  const [filteredOffers, setFilteredOffers] = useState<UserSaleOffer[]>(ctOffers)

  useEffect(() => {
    const offersFiltered = getFilteredUserSaleOffers(filterText, ctOffers, currencyList)
    setFilteredOffers(offersFiltered)
  }, [filterText, ctOffers])

  return (
    <CustomCard className='mb-4'>
      <ClimatetradeOffersFilter
        filterText={filterText}
        onChange={(value) => setFilterText(value)}
        length={filteredOffers.length}
      />
      <Divider />
      <CustomTable
        dataSource={filteredOffers}
        columns={ctOffersColumns}
        rowKey={(item: UserSaleOffer) => item.id}
        rowClassName={'fade-animation'}
      />
    </CustomCard>
  )
}

export default ClimatetradeOffersCard
